// extracted by mini-css-extract-plugin
export default {"tabLinks":"TabLinks_tabLinks__LIZAj","tabLinks__tabLink":"TabLinks_tabLinks__tabLink__PR8Lr"};